import dayjs from 'dayjs';

export enum FileDataType {
  image,
  pdf,
  notSupported,
}

const extensions = new Map([
  ['application/pdf', '.pdf'],
  ['image/png', '.png'],
  ['image/jpg', '.jpg'],
  ['image/jpeg', '.jpeg'],
]);

const types = new Map([
  ['.pdf', 'application/pdf'],
  ['.png', 'image/png'],
  ['.jpg', 'image/jpg'],
  ['.jpeg', 'image/jpeg'],
]);

export function mapFileTypeToFileDataType(
  fileType: string | undefined,
): FileDataType {
  switch (fileType) {
    case 'application/pdf':
      return FileDataType.pdf;
    case 'image/png':
    case 'image/jpg':
    case 'image/jpeg':
      return FileDataType.image;
    default:
      return FileDataType.notSupported;
  }
}

export function mapTypeToExtension(fileType: string): string | null {
  const extension = extensions.get(fileType);
  return extension ?? null;
}

export function mapExtensionToType(extension: string): string | null {
  const type = types.get(extension);
  return type ?? null;
}

export function getCertificateFilename(
  name: string | null,
  date: string | null,
): string {
  const file = name ? name.split(' ').join('_') : 'Certificate';
  const formattedDate = date ? dayjs(date).format('YYYY-MM-DD') : '';
  return [file, formattedDate].filter((part) => part).join('_');
}
